// src/pages/packProductsPage.js
/**
 * Stock Management Page
 * 
 * Tabbed interface for stock management:
 * - Tab 1: Unified Stock (default) - All products with calculated quantities
 * - Tab 2: Pack Products Management - Manage pack-based products
 */

import React from 'react';
import { Tabs } from 'antd';
import { DatabaseOutlined, InboxOutlined } from '@ant-design/icons';
import UnifiedStockTab from '../components/stock/UnifiedStockTab';
import PackProductsTab from '../components/stock/PackProductsTab';
import './packProductsPage.css';

const PackProductsPage = () => {
    // Tab items configuration
    const items = [
        {
            key: '1',
            label: (
                <span>
                    <DatabaseOutlined />
                    Stock Unificado
                </span>
            ),
            children: <UnifiedStockTab />,
        },
        {
            key: '2',
            label: (
                <span>
                    <InboxOutlined />
                    Gestión de Packs
                </span>
            ),
            children: <PackProductsTab />,
        },
    ];

    return (
        <div className="stock-page-container">
            {/* Header */}
            <div className="stock-page-header">
                <h1>
                    <DatabaseOutlined />
                    Gestión de Stock
                </h1>
            </div>

            {/* Tabbed Content */}
            <Tabs 
                defaultActiveKey="1" 
                items={items} 
                type="card" 
                className="stock-tabs"
            />
        </div>
    );
};

export default PackProductsPage;
